window._goober = Object.assign(document.createElement('style'), {
  innerHTML: ' ',
  id: '#_goober',
});

import { h } from 'preact';
import { setup } from 'goober';

import WidgetHTMLElement from './WidgetHTMLElement';

setup(h);

if (!customElements.get('chat-widget')) {
  customElements.define('chat-widget', WidgetHTMLElement);
}

function mountOnce() {
  if (!document.querySelector('chat-widget')) {
    const el = document.createElement('chat-widget');
    document.body.appendChild(el);
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountOnce);
  } else {
    mountOnce();
  }
}
